export default __webpack_public_path__ + "static/media/NotoSans-Light.f8729880.otf";